import gql from "graphql-tag";
import { RequestCreationResponseFragment, RequestListFragment } from "./fragments";

export const createRequest = gql`
  mutation addRequest($input: RequestCreationInput!) {
    addRequest(input: $input) {
      message
      code
      error
      data {
        ...RequestCreationResponseFragment
      }
    }
  }
  ${RequestCreationResponseFragment}
`;
export const UPDATE_REQUEST = gql`
  mutation updateRequest($input: RequestUpdateInput!) {
    results:updateRequest(input: $input) {
      message
      code
      error
      data {
        ...RequestCreationResponseFragment
      }
    }
  }
  ${RequestCreationResponseFragment}
`;

export const acceptRequest = gql`
  mutation acceptRequest($input: RequestAcceptInput!) {
    acceptRequest(input: $input) {
      message
      code
      error
      data {
        ...RequestListFragment
      }
    }
  }
  ${RequestListFragment}
`;

export const declineRequest = gql`
  mutation declineRequest($input: RequestDeclineInput!) {
    declineRequest(input: $input) {
      message
      code
      error
      data {
        ...RequestListFragment
      }
    }
  }
  ${RequestListFragment}
`;

export const updateRequestEvent = gql`
  mutation newEventRequest($input: RequestNewEventInput!) {
    newEventRequest(input: $input) {
      message
      code
      error
      data {
        ...RequestListFragment
      }
    }
  }
  ${RequestListFragment}
`;
